<!-- =========================================================================================
  File Name: CompanyEitButtons.vue
  Description: Entity Edit buttons
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="company-edit-buttons">
    <!-- Save & Cancel Button -->
    <div class="vx-row">
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-start">
          <vs-button
              class="my-4"
              @click="cancel"
          >
            Cancel
          </vs-button>
        </div>
      </div>
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button
              class="my-4"
              @click="saveChanges"
              color="light"
              :disabled="!validateForm"
          >
            Save
          </vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data () {
    return {

    }
  },
  methods: {
    validateForm () {
      return !this.vErrors.any()
    },
    saveChanges () {
      this.$emit('save');
    },
    cancel () {
      this.$emit('cancel');
    },
  }
}
</script>
